import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import request from "@/util/request";
export default {
  name: "UserList",
  data() {
    let validateStruct_Name = (rule, value, callback) => {
      console.log("kaisidiyibd");
      console.log(value);
      if (value === this.repeatName && this.dialogVisible === true) {
        callback();
      } else {
        request.get('/user/getUserByName', {
          params: {
            userName: value
            // areaId:this.parentNodeDate.parentId
          }
        }).then(res => {
          if (res == 0) {
            callback();
          } else if (res == 1) {
            callback(new Error("用户名重复，重新输入！"));
            // window.alert("该用户已存在,添加失败!")
          }
        });
      }
    };

    const treeData = [];
    const AreaData = [];
    return {
      dialogImageUrl: '',
      ip: localStorage.getItem("ip"),
      //ip地址
      url: '',
      srcList: ['https://jc.yunzhankeji.cloud/resource/082750/image/jyzz.png?t=1690787212362'],
      treeData: JSON.parse(JSON.stringify(treeData)),
      AreaData: JSON.parse(JSON.stringify(AreaData)),
      defaultProps: {
        children: 'children',
        label: 'roleName'
      },
      areaProps: {
        children: 'children',
        label: 'areaName'
      },
      form: {},
      editform: {},
      name: '',
      typeqqq: [],
      dialogFormVisible: false,
      dialogVisible: false,
      singVisible: false,
      findUser: '',
      session: sessionStorage.getItem("createBy"),
      tablee: [],
      multipleSelection: [],
      show: false,
      scrollHeight: '400px',
      scrollWidth: '100%',
      roleKey: [],
      areaKey: [],
      editRoleKey: [],
      roleId: [],
      areaArray: [],
      roleArray: [],
      arid: [],
      shuru: '',
      currentPage: 1,
      pageSize: 10,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      value: true,
      selectvalue: '',
      selectvalue2: '',
      //工具箱
      toolBox: [],
      //安全帽
      caps: [],
      //工具箱新建下拉框
      toolBoxSelect: '',
      //安全帽新建下拉框
      capsSelect: '',
      //工具箱修改下拉框
      toolBoxSelectUpdate: '',
      //安全帽修改下拉框
      capsSelectUpdate: '',
      casvalue: [],
      modalKey: 0,
      setKesLabel: {
        value: 'areaId',
        label: 'areaName',
        children: 'children',
        multiple: true
      },
      repeatName: '',
      //判断名字是否重复
      repeatName1: '',
      //判断密码是否为空
      repeatName2: '',
      //判断角色是否为空
      rules: {
        userName: [{
          required: true,
          min: 1,
          max: 50,
          message: '用户名不能为空',
          trigger: 'blur'
        }, {
          validator: validateStruct_Name,
          required: true,
          message: '用户名重复或不规范，重新输入',
          trigger: 'blur'
        }],
        userAlias: [{
          required: true,
          min: 1,
          max: 50,
          message: '姓名不能为空',
          trigger: 'blur'
        }
        // {  validator: validateStruct_Name,required: true, message: '用户名重复或不规范，重新输入', trigger: 'blur'}
        ],

        passWord: [{
          required: true,
          min: 1,
          max: 50,
          message: '密码不能为空',
          trigger: 'blur'
        }
        // {  validator: validateStruct_Name,required: true, message: '用户名重复或不规范，重新输入', trigger: 'blur'}
        ]
      },

      imageUrl: '',
      canvasDom: null,
      ctx: null,
      isDowm: false,
      lineWidth: 6,
      // 画笔的线条粗细
      lineColor: "#000000",
      // 画笔的颜色
      bgColor: '',
      // 画布的背景颜色
      resultImg: '',
      // 最终画布生成的base64图片
      isCrop: true,
      // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      isClearBgColor: false,
      //是否在清空时，也清空画布背景
      format: "image/png",
      //生成图片的格式  image/jpeg(jpg格式下生成的图片透明背景会变黑色请慎用或指定背景色)
      // quality: 0.92,
      upload: {
        // 设置上传的请求头部
        // headers: { token: getToken(), "tenant-id": getTenantId() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/media/upload/coursefile"
      },
      disabled: false,
      disabled1: false,
      testMap: {
        username: "isptest",
        passwd: "579b7a60029848d0fc88d26bc7886fa26b593e48df143040b500c6a7cf5b6c37",
        time_stamp: "1694424423998"
      }
    };
  },
  // mounted() {
  //   this.canvasDom = this.$refs.saveCanvas;
  //   this.ctx = this.canvasDom.getContext("2d"); //获得 2d 上下文对象
  // },
  created() {
    // this.dialogFormVisible = false
    // this.show = false
    // console.log(sessionStorage.getItem("createBy"))
    this.load();
    this.query();
  },
  methods: {
    //工具箱下拉框数据
    getToolBox() {
      request.get('/order/getToolBox').then(res => {
        this.toolBox = res.data;
      });
    },
    //安全帽下拉框数据
    getCaps() {
      request.get('/cap/usreUserQueryList').then(res => {
        this.caps = res;
      });
    },
    //打开修改弹窗安全帽下拉框数据
    getCaps1() {
      request.get('/cap/queryList').then(res => {
        this.caps = res;
      });
    },
    uploadSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res);
      this.form.userSign = file.response.data;
      this.url = res.data;
    },
    editUploadSuccess(res) {
      this.editform.userSign = res.data;
    },
    getStructByName(rule, value, callback) {
      request.get('/user/getUserByName', {
        params: {
          userName: value
          // areaId:this.parentNodeDate.areaId
        }
      }).then(res => {
        if (res.code === "0") {
          callback();
        } else {
          callback(new Error("用户名重复，重新输入！"));
        }
      });
    },
    load() {
      request.post("/role/tree").then(res => {
        this.treeData = res.data.lists;
        for (let i = 0; i < res.data.lists.length; i++) {
          // if (res.data.lists[i].authorityId == 1) {
          //   res.data.lists[i].authorityId = "查看"
          // } else if (res.data.lists[i].authorityId == 2) {
          //   res.data.lists[i].authorityId = "修改"
          // } else if (res.data.lists[i].authorityId == 3) {
          //   res.data.lists[i].authorityId = "删除"
          // }
          // this.tablee[i].createDate = this.formatDate(res.data.lists[i].createDate, "yyyy-MM-dd hh:mm:ss");
        }
      });
    },
    xinjian() {
      this.imageUrl = '';
      this.selectvalue2 = '';
      this.areaArray = [];
      this.casvalue = [];
      this.capsSelect = '';
      this.form = {
        userName: ''
      };
      this.dialogFormVisible = true;
      this.repeatName = this.form.userName;
      this.disabled = false;
      this.area();
      request.get('/area/useruselist').then(res => {
        this.AreaData = res.data.structList;
      });
      request.get('/area/useruselist').then(res => {
        this.AreaData = res.data.structList;
      });
      this.toolBox = [];
      this.caps = [];
      this.getToolBox();
      this.getCaps();
      // this.$refs['upload'].clearFiles()
      // this.arid =[];
    },

    onSubmit(formName) {
      console.log(this.form);
      this.disabled = true;
      this.repeatName = this.form.userName;
      this.repeatName1 = this.form.passWord;
      // this.repeatName2 = this.form.roleId
      this.repeatName2 = this.form.userAlias;
      this.form.roleId = this.selectvalue2;
      this.form.areaId = "," + this.areaArray + ",";
      this.form.createBy = sessionStorage.getItem('userName');
      // this.form.areaId = this.areaArray + ""
      // if (this.selectvalue2.length == 1) {
      this.$refs[formName].validate(valid => {
        this.repeatName = this.form.userName;
        this.repeatName1 = this.form.passWord;
        // this.repeatName2 = this.form.roleId
        this.repeatName2 = this.form.userAlias;
        //工具箱下拉框
        this.form.toolId = this.toolBoxSelect;
        //安全帽下拉框
        this.form.capIndex = this.capsSelect;
        this.form.rentalUserIndex = sessionStorage.getItem("rentalUserIndex");
        if (valid) {
          // this.$alert('确定添加该用户吗', '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     console.log(action)
          //
          //   }
          // });
          request.post("/user/createUser", this.form).then(res => {
            this.tablee = res.data;
            this.dialogFormVisible = false;
            this.query();
            let map = {
              rentalUserIndex: sessionStorage.getItem("rentalUserIndex")
            };
            request.post('/user/less', map).then(res => {
              console.log(res);
            });
            // if (res.code === '0') {
            //   this.disabled = true
            // }
          });

          setTimeout(() => {
            this.disabled = false;
          }, 3000);

          //
        } else {
          if (this.repeatName == null || this.repeatName == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入用户名!'
            });
            setTimeout(() => {
              this.disabled = false;
            }, 3000);
            return false;
          } else if (this.repeatName1 == null || this.repeatName1 == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入密码!'
            });
            setTimeout(() => {
              this.disabled = false;
            }, 3000);
            return false;
          } else if (this.repeatName2 == null || this.repeatName2 == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入姓名!'
            });
            setTimeout(() => {
              this.disabled = false;
            }, 3000);
            return false;
          }
        }
      });
      // } else {
      //   this.$message.error("新建用户角色只能选择一个,保存失败!")
      // }
    },

    editSubmit(formName) {
      console.log(this.editform.rentalUserIndex);
      //工具箱下拉框
      this.editform.toolId = this.toolBoxSelectUpdate;
      this.editform.roleId = this.selectvalue2;
      //安全帽下拉框
      this.editform.capIndex = this.capsSelectUpdate;
      if (this.areaArray.length === 0) {
        // this.editform.areaId = "," + this.areaArray + ","
      } else {
        this.editform.areaId = "," + this.areaArray + ",";
        this.form.createBy = sessionStorage.getItem('userName');
        this.editform.updateBy = sessionStorage.getItem('userName');
        // this.editform.rentalUserIndex =
      }

      console.log(this.roleArray);
      console.log(this.roleKey);
      this.$refs[formName].validate(valid => {
        // this.repeatName = this.editform.userName
        if (valid) {
          request.post("/user/update", this.editform).then(res => {
            if (res.code === '0') {
              this.tablee = res.data;
              this.dialogVisible = false;
              this.query();
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
            } else {
              this.$message({
                type: 'info',
                message: '区域修改失败，有未检测的工单'
              });
            }
          });
        } else {
          console.log('error submit!!');
          this.$message({
            type: 'error',
            message: '修改数据不正确,请重新输入!'
          });
          return false;
        }
      });
    },
    update(row) {
      this.getCaps1();
      this.imageUrl = '';
      this.casvalue = [];
      this.areaArray = [];
      console.log(row);
      this.editform = JSON.parse(JSON.stringify(row));
      this.url = row.userSign;
      this.repeatName = JSON.parse(JSON.stringify(row.userName));
      this.dialogVisible = true;
      for (let i = 0; i < this.editform.areaId.toString().split(",").length; i++) {
        this.casvalue.push(parseInt(this.editform.areaId.toString().split(",")[i]));
      }
      //工具箱下拉框
      this.toolBox = [];
      this.getToolBox();
      this.toolBoxSelectUpdate = this.editform.toolId;
      //安全帽下拉框
      this.caps = [];
      this.getCaps();
      this.capsSelectUpdate = this.editform.capIndex;
      this.disabled = false;
      request.post("/cap/updateAllocationToZero", this.editform.capIndex).then(res => {
        console.log(res);
      });
      console.log(row);
      // request.post("/role/userUseList", {}).then(res => {
      //   this.treeData = res.data.lists
      //   console.log(res.data.lists)
      //   for (let i = 0; i < res.data.lists.length; i++) {
      //     console.log(res.data.lists[i].roleName)
      //     console.log(res.data.lists[i].roleId)
      //   }
      //   // if (this.editform.roleId.size == 1) {
      //     // this.roleKey.push(this.editform.roleId);
      this.selectvalue2 = this.editform.roleId;
      //   // } else {
      //   //   this.roleKey = this.editform.roleId.toString().split(",");
      //   // }
      //   console.log(this.roleKey)

      if (this.editform.areaId.length == 1) {
        this.areaKey.push(this.editform.areaId);
      } else {
        this.areaKey.push(this.editform.areaId.toString().split(","));
      }

      //   // console.log(this.typeqqq )
      // })
      request.get('/area/useruselist').then(res => {
        // console.log(res);
        this.AreaData = res.data.structList;
      });

      // request.post("/user/getpwd", {
      //   params: {
      //     name: row.userName
      //   }
      // }).then(res => {
      //   res.data
      // })
    },

    del(userId, capIndex) {
      request.post("/cap/updateAllocationToZero", capIndex).then(res => {
        console.log(res);
      });
      request.delete("/user/delete/" + userId).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.query();
        } else {
          this.$message({
            message: '删除失败！',
            type: 'error'
          });
        }
      });
    },
    query() {
      this.tablee = [];
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        "roleId": this.selectvalue
      };
      request.post("/user/list", userMap).then(res => {
        console.log(res.data.lists[0].userName);
        console.log(sessionStorage.getItem("userName"));
        console.log(res.data.lists);
        console.log(typeof res.data.lists);
        this.tablee = res.data.lists;
        this.total = res.data.total;
        if (res.code === '500') {
          this.dialogVisible = false;
        }
      });
    },
    chaxun() {
      this.shuru = '';
      this.selectvalue = '';
      this.currentPage = 1;
      this.load();
      this.query();
    },
    select() {
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        "roleId": this.selectvalue
      };
      request.post("user/list", userMap).then(res => {
        this.tablee = res.data.lists;
        this.total = res.data.total;
      });
    },
    area() {
      request.get('/area/list').then(res => {
        // console.log(res);
        this.AreaData = res.data.structList;
      });
    },
    // handleCheckChange(data, checked, indeterminate) {
    handleCheckChange() {
      console.log(this.selectvalue2);
      let map = {
        rentalUserIndex: sessionStorage.getItem("rentalUserIndex")
      };
      if (this.selectvalue2 == 2) {
        request.post('/user/queryCreateNum', map).then(res => {
          console.log(res);
          // this.AreaData = res.data.structList;
          if (res == 0) {
            this.disabled = true;
            this.$message({
              message: '可创建的检测人员用户数量不足！',
              type: 'error'
            });
          } else {
            this.disabled = false;
          }
        });
      } else {
        this.disabled = false;
      }

      // this.roleArray = [];
      // if (checked.checkedKeys != null && checked.checkedKeys.length>0) {
      //   if (checked.checkedKeys.length > 1 ) {
      //     Object.keys(checked.checkedNodes).forEach(key=>{
      //       Object.keys(checked.checkedNodes[key]).forEach(keys=>{
      //         // if (checked.checkedNodes[key].areaLevel === 4) {
      //           if (!this.roleArray.includes(checked.checkedNodes[key].roleId)){
      //             this.roleArray.push(checked.checkedNodes[key].roleId) ;
      //           }
      //         // }
      //         let arr =keys;
      //         console.log("arr值:"+arr)
      //       });
      //     });
      //   }else {
      //     this.roleArray =checked.checkedKeys;
      //   }
      // } else {
      //   this.roleArray = [];
      // }
      // console.log(data.roleId)
      // console.log(data)
      // // console.log(checked)
      // console.log(this.roleArray)
      // this.form.roleId = data.roleId
      // console.log(this.form.roleId)
    },

    editRoleFun(data, checked) {
      this.roleArray = [];
      if (checked.checkedKeys != null && checked.checkedKeys.length > 0) {
        if (checked.checkedKeys.length > 1) {
          Object.keys(checked.checkedNodes).forEach(key => {
            Object.keys(checked.checkedNodes[key]).forEach(keys => {
              if (checked.checkedNodes[key].areaLevel === 2) {
                if (!this.roleArray.includes(checked.checkedNodes[key].roleId)) {
                  this.roleArray.push(checked.checkedNodes[key].roleId);
                }
              }
              let arr = keys;
              console.log("arr值:" + arr);
            });
          });
          // console.log(arr)
        } else {
          this.roleArray = checked.checkedKeys;
        }
        // console.log(this.tvDepartmentSelArr+"-----555");
        // console.log( this.tvDepartmentSelArr+"-----111");
      } else {
        this.roleArray = [];
        // console.log(this.tvDepartmentSelArr+"-----777");
      }

      console.log("tvDepartmentSelArr数组值:" + this.roleArray);
      console.log(checked.checkedKeys);
    },
    areaCheckChange(data, checked, casvalue) {
      console.log(casvalue);
      console.log(this.setKesLabel.value);
      console.log(data);
      console.log(checked);
      console.log(this.casvalue);
      this.areaArray = [];
      for (let i = 0; i < this.casvalue.length; i++) {
        // console.log(this.$refs.cascaderAddr.getCheckedNodes()[i].pathLabels)
        for (let j = 0; j < this.casvalue[i].length; j++) {
          if (j == 2) {
            console.log(2222);
            // this.form.areaId = this.casvalue[i][j];
            this.areaArray.push(this.casvalue[i][j]);
            // this.areaArray = this.casvalue[i][j];
          }
        }
      }

      console.log("areaArray数组值:" + this.areaArray);
      // this.areaArray = [];
      // if (checked.checkedKeys != null && checked.checkedKeys.length>0) {
      //   if (checked.checkedKeys.length > 1 ) {
      //     Object.keys(checked.checkedNodes).forEach(key=>{
      //       Object.keys(checked.checkedNodes[key]).forEach(keys=>{
      //         if (checked.checkedNodes[key].areaLevel === 5) {
      //         if (!this.areaArray.includes(checked.checkedNodes[key].areaId)){
      //           this.areaArray.push(checked.checkedNodes[key].areaId) ;
      //         }
      //         }
      //         let arr =keys;
      //         console.log("arr值:"+arr)
      //       });
      //     });
      //   }else {
      //     this.areaArray =checked.checkedKeys;
      //   }
      // } else {
      //   this.areaArray = [];
      // }
      // console.log("tvDepartmentSelArr数组值:"+this.areaArray)
      // console.log(checked.checkedKeys)
      // this.arid.push(data.areaId)
    },

    editAreaCheckChange(data, checked) {
      // console.log(casvalue);
      // console.log(this.setKesLabel.value)
      // console.log(data)
      // console.log(checked)
      // console.log(this.casvalue)
      // this.areaArray = [];
      // for (let i = 0; i < this.casvalue.length; i++) {
      //   // console.log(this.$refs.cascaderAddr.getCheckedNodes()[i].pathLabels)
      //   for (let j = 0; j < this.casvalue[i].length; j++) {
      //     if (j == 4) {
      //       console.log(2222);
      //       // this.form.areaId = this.casvalue[i][j];
      //       this.areaArray.push( this.casvalue[i][j]);
      //       // this.areaArray = this.casvalue[i][j];
      //     }
      //   }
      // }
      // console.log("areaArray数组值:" + this.areaArray)
      this.areaArray = [];
      if (checked.checkedKeys != null && checked.checkedKeys.length > 0) {
        if (checked.checkedKeys.length > 1) {
          Object.keys(checked.checkedNodes).forEach(key => {
            Object.keys(checked.checkedNodes[key]).forEach(keys => {
              if (checked.checkedNodes[key].areaLevel === 3) {
                if (!this.areaArray.includes(checked.checkedNodes[key].areaId)) {
                  this.areaArray.push(checked.checkedNodes[key].areaId);
                }
              }
              let arr = keys;
              console.log("arr值:" + arr);
            });
          });
        } else {
          this.areaArray = checked.checkedKeys;
        }
      } else {
        this.areaArray = [];
      }
      console.log("tvDepartmentSelArr数组值:" + this.areaArray);
      console.log(checked.checkedKeys);
      this.arid.push(data.areaId);
    },
    handleNodeClick() {
      // console.log(data);
      // console.log(data.roleId);
      this.findUser = this.selectvalue;
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        roleId: this.findUser
      };
      request.post("/user/list", userMap).then(res => {
        if (res.code === '0') {
          this.tablee = res.data.lists;
          this.total = res.data.total;
        } else {
          this.tablee = [];
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.dialogVisible = false;
      request.post("/cap/updateAllocationToOne", this.editform).then(res => {
        console.log(res);
      });
      this.editform = {};
      this.roleArray = [];
      this.areaArray = [];
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.query();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.query();
    },
    changeSwitch(row) {
      // this.roleKey = [];
      // this.areaKey = [];
      // if (this.editform.roleId.size == 1) {
      //   this.roleKey.push(this.editform.roleId);
      // } else {
      //   this.roleKey= this.editform.roleId.toString().split(",");
      // }
      // console.log(this.roleKey)
      // if (this.editform.areaId.length == 1) {
      //   this.areaKey.push(this.editform.areaId);
      // } else {
      //   this.areaKey= this.editform.areaId.toString().split(",");
      // }
      console.log(row);
      console.log(row.userId);
      this.editform = JSON.parse(JSON.stringify(row));
      this.editform.roleId = row.roleId;
      this.editform.areaId = row.areaId;
      this.form.createBy = sessionStorage.getItem('userName');
      this.editform.updateBy = sessionStorage.getItem('userName');
      request.post("/user/update", this.editform).then(res => {
        // this.tablee = res.data
        console.log(res);
        this.dialogVisible = false;
        this.query();
        // this.roleKey = [];
        // this.areaKey = [];
      });

      request.post("/cap/updateAllocationToZero", this.editform.capIndex).then(res => {
        console.log(res);
      });
    },
    handleChange(value) {
      console.log(value);
    },
    saveImg() {
      // const img = this.ctx.getImageData(0, 0, 600, 400);
      const url = this.canvasDom.toDataURL();
      const a = document.createElement("a");
      a.download = "图片";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, 600, 400);
    },
    handleReset() {
      this.$refs.esign.reset();
    },
    // 生成签字图  保存按钮
    handleGenerate() {
      this.$refs.esign.generate() // 使用生成器调用把签字的图片转换成为base64图片格式
      .then(res => {
        this.resultImg = res;
        this.singVisible = false;
        // 转成文件
        // var blob = this.dataURLtoBlob(res)
        // var tofile = this.blobToFile(blob, '签名.jpg')
        let map = {
          "sign": this.resultImg
        };
        request.post("/user/saveSign", map).then(res => {
          console.log(res);
          sessionStorage.setItem("qm", res.data.lists);
          console.log(sessionStorage.getItem("qm"));
        });
        // console.log(tofile)
      }).catch(err => {
        console.log(err);
        this.$message({
          type: "warning",
          message: "请签名后再生成签字图片"
        });
      });
      setTimeout(() => {
        // 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
        // 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储
        console.log('我是签字后的base64图片', this.resultImg);
      }, 200);
      // this.dialogVisible = false;
    },

    // 将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    handleAvatarSuccess(res, file) {
      // this.resultImg = URL.createObjectURL(file.raw);
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file);
      console.log(file.response.data);
      this.editform.userSign = file.response.data;
    },
    tosign() {
      // this.$router.push({path:'sign', query:{}});
      this.singVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      console.log(file.response.data);
      // this.dialogImageUrl = file.url;
      this.dialogImageUrl = file.response.data;
      this.singVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error('上传签名图片只能是 JPG 或者是 PNG 格式!');
      }
      // if (!isPNG) {
      //   this.$message.error('上传签名图片只能是 PNG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M || isPNG && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 张图片，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    serviceTest() {
      // let USE_UNT_NAME = "福州市园开安筑建设有限公司";
      // let USE_UNT_COD = "91350000154586155C";
      // let OIDNO = "TA121529";
      // let map = new Map;
      let map = {
        "USE_UNT_NAME": "wq测试企业（综合）",
        "USE_UNT_COD": "91350000154586155C",
        "OIDNO": "RD40589"
      };
      // map = JSON.stringify(map)
      // map.set(USE_UNT_NAME, "福州市园开安筑建设有限公司")
      // map.set(USE_UNT_COD, "91350000154586155C")
      // map.set(OIDNO, "TA121529")
      // map.setUSE_UNT_NAME(USE_UNT_NAME)
      // map.setUSE_UNT_COD(USE_UNT_COD)
      // map.setOIDNO(OIDNO)
      // let data = {
      //   'map': map
      // }
      console.log(typeof map);
      // request.post("http://211.138.144.117:9510/api/det/service/auth?username="+map.username+"&passwd="+map.passwd+"&time_stamp="+map.time_stamp
      request.post("/user/jkTest", map).then(res => {
        console.log(new Date().getTime());
        console.log(res);
        // for (let i = 0; i < res.data.length; i++) {
        //   console.log(res.data[i].token)
        //
        // }
        // console.log(res.data)
      });
      // axios.post("http:/211.138.144.117:9510/api/det/service/auth",map).then(res => {
      //   console.log(res)
      // })
    }
  }
};